export class TabStatuses {
    public static PENDING = 'PENDING';
    public static OPEN = 'OPEN';
    public static CLOSED = 'CLOSED';
    public static CANCELED = 'CANCELED';
    public static VACATED = 'VACATED';
    public static DELETED = 'DELETED';
}
